import * as _ from 'lodash';
import { PaymentWarnings } from './WageGroup';
import { AuditData } from './Audit';

/**
 * @typedef { import('./Claim').Claim } Claim
 * @typedef { import('./Payment').Payment } Payment
 * @typedef { import('./Attendance').Attendance } Attendance
 * @typedef { import('../server/ResponseContext').ResponseContext } ResponseContext
*/

export const certificationStates = Object.freeze({
    skipped: 0,
    pending: 1,
    rejected: 2,
    certified: 3,
    recalled: 4,
});

export const remunerationTypes = Object.freeze({
    claim: 0,
    calculatedMeeting: 1,
    calculatedTravel: 2,
    payment: 3,
});

export const remunerationOperations = Object.freeze({
    none: 0,
    remove: 1,
    certify: 2,
    rejectClaim: 3,
});

export class Payslip {
    constructor(obj) {
        if (_.isObjectLike(obj)) {
            this.AttendanceId = obj.AttendanceId;
            this.EnableLostIncome = obj.EnableLostIncome;
            this.NewClaimIds = obj.NewClaimIds;
            this.Remunerations = _.map(obj.Remunerations, x => new Remuneration(x));
            this.Warnings = _.map(obj.Warnings, x => new PayslipWarning(x));
        }
    }

    /**
     * 
     * @param {ResponseContext} ctx
     */
    resolve(ctx) {
        /** @type {Attendance} */
        this.Attendance = ctx.getAttendance(this.AttendanceId);
        /** @type {Claim[]} */
        this.NewClaims = ctx.getClaim(this.NewClaimIds);

        this.Remunerations.forEach(x => x.resolve(ctx));
        this.Warnings.forEach(x => x.resolve(ctx));
    }

    /**
     * 
     * @param {any} result
     * @param {ResponseContext} context
     */
    static mapResponse(result, context) {
        let res = new Payslip(result);
        res.resolve(context);
        return res;
    }
}

export class Remuneration {
    constructor(src) {
        this.Id = src.Id;
        this.ClaimId = src.ClaimId;
        this.PaymentIds = src.PaymentIds;
        this.CertificationState = src.CertificationState;
        this.RemunerationType = src.RemunerationType;
        this.AuditEntries = _.map(src.AuditEntries, x => new AuditData(x));
    }

    /**
     * @param {ResponseContext} context
     */
    resolve(ctx) {
        this.Claim = ctx.getClaim(this.ClaimId);
        this.Payments = ctx.getPayment(this.PaymentIds);
        _.forEach(this.AuditEntries, x => x.resolve(ctx));
    }
}

export class PayslipWarning {
    constructor(src) {
        this.WageTypeId = src.WageTypeId;
        this.Warning = src.Warning;
        this.Amount = src.Amount;
        this.Overflow = src.Overflow;
    }

    /**
     * @param {ResponseContext} context
     */
    resolve(ctx) {
        this.WageType = ctx.getWageType(this.WageTypeId);

        this.message = PaymentWarnings.getMessage(this.Warning);
        this.location = PaymentWarnings.getLocation(this.Warning, this.WageType && this.WageType.display);
    }
}
